// src/services/printer/printerStorage.js
export class PrinterStorage {
  static save(printers, configs) {
    try {
      localStorage.setItem("printerConfigurations", JSON.stringify(configs));
      localStorage.setItem("connectedPrinters", JSON.stringify(printers));
    } catch (error) {
      console.error("Error saving printer configurations:", error);
    }
  }

  static load() {
    try {
      return {
        configs:
          JSON.parse(localStorage.getItem("printerConfigurations")) || {},
        printers: JSON.parse(localStorage.getItem("connectedPrinters")) || [],
      };
    } catch (error) {
      console.error("Error loading printer configurations:", error);
      return { configs: {}, printers: [] };
    }
  }
}
